import { EmailDomainLookupResponse } from '../../api-models';
import { HTTPMethod } from '../../types/enums';
import { AdapterInterface } from '../../types/global';
import BaseAdapter from './baseAdapter';

export default class EmailDomainLookup extends BaseAdapter<EmailDomainLookupResponse> implements AdapterInterface {
  rawResponse: EmailDomainLookupResponse;

  async adaptResponse(emailDomain: string): Promise<EmailDomainLookupResponse> {
    const requestBody = {
      email_domain: emailDomain,
    };

    await this.fetchApiResponse('/api/domain-lookup', HTTPMethod.Post, requestBody);
    return this.displayResponse();
  }

  async displayResponse(): Promise<EmailDomainLookupResponse> {
    return this.rawResponse;
  }
}
